import {DrillDownStatisticsLevel} from '../../../../../types/api/drillDown';

export function getKeyFromLevels(levels: DrillDownStatisticsLevel[]): string {
  return levels.map((level) => level.value).join('-');
}
